export default "__VITE_ASSET__107acb69__"